import React from 'react';

import styled from 'styled-components';

import { Animation } from 'components/lottie-animations/cart-loading';

const LoadingGraphic = styled.div`
  height: 13.75rem;
  margin: 1.875rem;
  ${Styles.desktop`
    margin: 3.125rem;
  `}
`;

const LoadingAnimation = () => (
  <LoadingGraphic data-testid="cart-loading-graphic">
    <React.Suspense fallback={null}>
      <Animation />
    </React.Suspense>
  </LoadingGraphic>
);

export default LoadingAnimation;
